import { Component, ElementRef, HostBinding, ViewChild } from '@angular/core';
import { ExcelqandaService } from '../excelqanda.service';
import { AlertPopup, HttpLoader } from 'app/app.config';
import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { saveAs as importedSaveAs } from "file-saver";
import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';
import { LlmService } from 'app/services/llm.service';
import { StaffRoomService } from 'app/components/staff-room/staff-room.service';
import { ChatService } from 'app/components/chat-list/chat.service';
import { finalize, map } from 'rxjs';
@Component({
  selector: 'app-excel-upload',
  templateUrl: './excel-upload.component.html',
  styleUrls: ['./excel-upload.component.scss'],
  standalone: false
})
export class ExcelUploadComponent {

  @HostBinding('class.flex-grid') leftBarClass = true;
  @HostBinding('style.width') flexwidth = '100%';
  showPaginateSpinner: boolean = false;

  excelSheetForm: FormGroup = new FormGroup({});
  sheetDataForm: FormGroup = new FormGroup({});
  sheetslist = ['sheet 1', 'sheet 2', 'sheet 3', 'sheet 4'];
  showsheetform: boolean = false;
  showDropdown: boolean = false;
  downloadFilename: any;
  sheetDataList: any = [];
  showsheetDataList: boolean = false;
  elibraryList: any = [];
  selectedClassList: any;
  ClassListData: any[] = [];
  Class_id: any;

  // Document list properties
  documentList: any[] = [];
  showDocumentList: boolean = false;
  documentListLoading: boolean = false;
  isUserRole: any = "";
  selectedDocuments: Set<string> = new Set();
  isModelType: any = "";
  selectAll: boolean = false;
  @ViewChild('elibraryFileInput') elibraryFileInput!: ElementRef;

  // History properties
  showHistory: boolean = false;
  historyList: any[] = [];
  filteredHistoryList: any[] = [];
  historyLoading: boolean = false;
  historySearchText: string = '';
  constructor(private excelservice: ExcelqandaService, private alert: AlertPopup, private fb: FormBuilder, private llmService: LlmService, private confirmService: ConfirmationDialogService, private staffRoomService: StaffRoomService, private chatService: ChatService, private httpLoader: HttpLoader) {

  }

  ngOnInit() {

    // this.httpLoader.showLoader();

    // Initialize user role
    this.isUserRole = window.localStorage.getItem('user_role');
    this.isUserRole = this.isUserRole ? parseInt(this.isUserRole.replace(/\"/g, "")) : 0;

    this.excelSheetForm = this.fb.group({
      file_name: '',
      sheets: this.fb.array([]),
    });

    this.sheetDataForm = this.fb.group({
      file_name: '',
      sheet_list: this.fb.array([
        this.fb.group({
          sheet_name: '',
          sheet_data: this.fb.array([
            this.fb.group({
              question: '',
              answer: ''
            })
          ])
        })
      ]),
    });
    // this.generateSheetForm();
    this.getllmUserInfo();
    this.loadHistory();

    // this.showsheetDataList = true;
    //  let result = this.getmockData();
    //   this.sheetDataList = result['data'];
  }

  generateSheetForm() {
    let i = 0;
    console.log(this.sheetslist);
    while (i < this.sheetslist.length) {
      this.addSkills();
      this.skills.controls[i]['controls']["sheet_name"].setValue(this.sheetslist[i]['sheet_name']);
      i++;
    }

  }

  get skills(): any {
    return this.excelSheetForm.get("sheets") as FormArray;
  }

  get sheetlist() {
    return this.sheetDataForm.get('sheet_list') as FormArray;
  }



  newSkill(): FormGroup {
    return this.fb.group({
      sheet_name: ['', Validators.required],
      question_field: ['', Validators.required],
      answer_field: ['', Validators.required],
    })
  }

  addSkills() {
    this.skills.push(this.newSkill());
  }

  removeSkill(i: number) {
    this.confirmService.openConfirmDialog('', {
      title: 'Confirmation',
      message: 'Are you sure, you want to remove?',
      btnOkText: 'YES',
      btnCancelText: 'NO',
      onClose: (data: any) => {
        if (data) {
          this.skills.removeAt(i);
          if (this.skills.controls.length == 0) {
            this.showsheetform = false;
          }
        }
      }
    });
  }

  getColumns(i: number) {
    return this.sheetslist[i]['columns'][0];
  }


  chooseUploadFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      return;
    }

    const companyId = localStorage.getItem('company_id');

    if (!companyId) {
      this.alert.showErrorMessage('Company ID not found.');
      input.value = '';
      return;
    }

    const fileLLMformData = new FormData();

    fileLLMformData.append('file', file, file.name);
    fileLLMformData.append('client_id', companyId);

    this.showPaginateSpinner = true;
    this.httpLoader.showLoader();

    this.excelservice.uploadSummaryPdf(fileLLMformData)
      .pipe(
        finalize(() => {
          this.showPaginateSpinner = false;
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (res: any) => {

          if (res?.sheets?.length > 0) {

            // Reset file input
            input.value = '';

            // Update sheets list
            this.sheetslist = res.sheets;

            // Update file name
            this.excelSheetForm.controls['file_name']
              .setValue(res.file_name);

            // Show sheet dropdown
            this.showDropdown = true;

            // Generate sheet form
            this.generateSheetForm();

            this.showsheetform = true;

          } else {
            this.alert.showErrorMessage(
              'No sheets found in the uploaded file.'
            );
          }
        },

        error: (error: HttpErrorResponse) => {
          this.httpLoader.hideLoader();

          this.alert.showErrorMessage(
            error?.error?.message || 'Unable to upload file. Please try again.'
          );

          input.value = '';
        }
      });
  }

  toggleSheet(index: number): void {
    this.sheetDataList.forEach((item: any, i: any) => {
      item.expanded = i === index ? !item.expanded : false;
    });
  }

  onSubmit(): void {

    // Validate selected documents
    if (this.selectedDocuments.size === 0) {
      this.alert.showAlertMessage({
        message: 'Please select a document'
      });
      return;
    }

    // Validate form
    if (this.excelSheetForm.invalid) {
      this.excelSheetForm.markAllAsTouched();

      this.alert.showAlertMessage({
        message: 'Fill all required fields'
      });
      return;
    }

    const companyId = localStorage.getItem('company_id');
    const llmToken = localStorage.getItem('llm_token');

    if (!companyId || !llmToken) {
      this.alert.showErrorMessage('Authentication details not found.');
      return;
    }

    // Prepare payload
    const payload = {
      ...this.excelSheetForm.getRawValue(),
      class_id: this.Class_id,
      model_type: this.isModelType,
      doc_id: Array.from(this.selectedDocuments),
      client_id: companyId,
      'x-auth-token': llmToken
    };

    this.showPaginateSpinner = true;

    this.alert.showAlertMessage({
      message: 'Data is processing'
    });

    this.excelservice.getSheetData(payload)
      .pipe(
        finalize(() => {
          this.showPaginateSpinner = false;
        })
      )
      .subscribe({
        next: (result: any) => {

          if (result?.data?.length > 0) {

            // Update sheet data
            this.sheetDataList = result.data;
            this.downloadFilename = result.file_name;

            // Update UI
            this.showsheetDataList = true;
            this.showsheetform = false;

            // Reset form
            this.excelSheetForm.reset();

            // Add processing history
            this.addToHistory(result);

            this.alert.showAlertMessage({
              message: 'Data loaded successfully'
            });

          } else {
            this.alert.showAlertMessage({
              message: 'No data found in sheet'
            });
          }
        },

        error: (error: any) => {
          this.alert.showErrorMessage(
            error?.error?.message ||
            'Failed to process data. Please try again.'
          );
        }
      });
  }



  downloadSheet(): void {
    const companyId = localStorage.getItem('company_id');

    if (!this.downloadFilename || !companyId) {
      this.alert.showErrorMessage(
        'Download information is missing. Please try again.'
      );
      return;
    }

    const fileLLMformData = new FormData();

    fileLLMformData.append('file_name', this.downloadFilename);
    fileLLMformData.append('client_id', companyId);

    this.httpLoader.showLoader();

    this.excelservice.downloadSheet(fileLLMformData)
      .pipe(
        finalize(() => {
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: Blob) => {
          const now = new Date();

          const datestring = [
            now.getDate(),
            now.getMonth() + 1,
            now.getFullYear()
          ].join('-') + '_' +
            [
              now.getHours(),
              now.getMinutes()
            ].join('-');

          importedSaveAs(response, `${datestring}.xlsx`);

          this.alert.showAlertMessage({
            message: 'Source document downloaded successfully',
            type: 2
          });
        },

        error: (error: any) => {
          this.alert.showErrorMessage(
            error?.error?.message ||
            'Unable to download the source document. Please try again.'
          );
        }
      });
  }


  closeSheet() {
    this.showsheetDataList = false;
    this.showsheetform = false; // optional – if you want to return to the form view
    this.showPaginateSpinner = false;

    this.excelSheetForm.reset();
    this.selectedClassList = "";
    this.documentList = [];
    this.selectedDocuments.clear();

    this.sheetDataList = [];
    this.downloadFilename = "";
    this.showDropdown = false;
    this.skills.clear();
  }


  getllmUserInfo() {
    this.llmService.llmUserInfo().subscribe({
      next: (response: any) => {
        this.llmService.LLM_classes = response['class_access'];
        this.getElibrary().then((result: any) => {

          this.elibraryList = result;
        });
      },
      error: (error: HttpErrorResponse) => {

      }
    })
  }

  getElibrary(): Promise<any[]> {
    const payload = {
      offset: 0,
      limit: 25,
      search: '',
      sort: 'time',
      data_type: true
    };

    return new Promise((resolve, reject) => {
      this.staffRoomService.getClassList(payload)
        .pipe(
          map((response: any) => {

            const tempList = response?.result ?? response?.chatList ?? [];

            this.ClassListData = tempList;

            const classIds = new Set(
              this.llmService.LLM_classes.map((id: any) => String(id))
            );

            return tempList.filter((item: any) =>
              classIds.has(String(item.group_id))
            );
          })
        )
        .subscribe({
          next: (elibraryList) => resolve(elibraryList),
          error: (error) => reject(error)
        });
    });
  }

  dropdownSelectedClass(event: any) {


    this.Class_id = event.value['group_id'];
    this.selectedClassList = event.value;
    this.isModelType = event.value['model_type'];

    // Load documents for the selected class
    this.getDocumentList();
  }

  getDocumentList(): void {

    if (!this.Class_id) {
      this.documentList = [];
      this.showDocumentList = false;
      this.documentListLoading = false;
      return;
    }

    this.documentListLoading = true;
    this.showDocumentList = true;

    const payload = {
      offset: 0,
      limit: 25,
      groupId: this.Class_id,
      is_doc_section: true
    };

    this.chatService.getMessageAttachments(payload)
      .pipe(
        finalize(() => {
          this.documentListLoading = false;
        })
      )
      .subscribe({
        next: (response: any) => {

          const documents = response?.recordList ?? [];

          this.documentList = documents.map((doc: any) => ({
            ...doc,
            views: doc.views ?? 1
          }));

        },

        error: (error: any) => {
          this.documentList = [];

          this.alert.showErrorMessage(
            error?.error?.message ||
            error?.error ||
            'Error loading documents. Please try again.'
          );
        }
      });
  }

  toggleDocumentSelection(document: any) {
    const id = document.llmfile_uuid || document.download_url;

    console.log(document);


    if (this.selectedDocuments.has(id)) {
      this.selectedDocuments.delete(id);
    } else {
      this.selectedDocuments.add(id);
    }
    this.updateSelectAllState();
  }

  toggleSelectAll() {
    if (this.selectAll) {
      this.selectedDocuments.clear();
    } else {
      this.documentList.forEach(doc => {
        const id = doc.llmfile_uuid || doc.download_url;
        this.selectedDocuments.add(id);
      });
    }
    this.selectAll = !this.selectAll;
  }

  updateSelectAllState() {
    this.selectAll = this.selectedDocuments.size === this.documentList.length && this.documentList.length > 0;
  }

  isDocumentSelected(document: any): boolean {
    const id = document.llmfile_uuid || document.download_url;
    return this.selectedDocuments.has(id);
  }

  downloadDocument(document: any) {
    if (document.download_url) {
      window.open(document.download_url, '_blank');
    }
  }

  getDocumentTitle(item: any): string {
    if (item.message && item.message !== 'undefined') {
      return item.message.replace(/<[^>]*>/g, ''); // Remove HTML tags
    }
    return item.file_path || 'No Title';
  }

  ngOnDestroy() {
    this.showsheetDataList = false;
    this.showsheetform = false;
  }

  // History Methods
  toggleHistory() {
    this.showHistory = !this.showHistory;
    if (this.showHistory && this.historyList.length === 0) {
      this.loadHistory();
    }
  }

  loadHistory(): void {
    const clientId = localStorage.getItem('company_id');

    if (!clientId) {
      this.historyList = [];
      this.filteredHistoryList = [];
      this.historyLoading = false;
      return;
    }

    const fileLLMformData = new FormData();
    fileLLMformData.append('client_id', clientId);

    this.historyLoading = true;

    this.excelservice.getFiles(fileLLMformData)
      .pipe(
        finalize(() => {
          this.historyLoading = false;
        })
      )
      .subscribe({
        next: (response: any) => {

          const files: string[] = Array.isArray(response?.Files)
            ? response.Files
            : [];

          const currentDate = new Date().toISOString();

          this.historyList = files.map((fileName: string) => ({
            file_name: fileName,
            class_name: 'Unknown',
            class_id: '',
            created_at: currentDate,
            status: 'completed',
            sheet_count: 0,
            sheet_data: [],
            download_filename: fileName
          }));

          this.filteredHistoryList = [...this.historyList];
        },

        error: (error: HttpErrorResponse) => {
          this.historyList = [];
          this.filteredHistoryList = [];

          this.alert.showErrorMessage(
            error?.error?.message ||
            'Unable to load processing history. Please try again.'
          );
        }
      });
  }

  filterHistory(): void {
    const searchTerm = (this.historySearchText || '').trim().toLowerCase();

    if (!searchTerm) {
      this.filteredHistoryList = [...this.historyList];
      return;
    }

    this.filteredHistoryList = this.historyList.filter((item: any) => {
      const fileName = (item.file_name || '').toLowerCase();
      const className = (item.class_name || '').toLowerCase();

      return fileName.includes(searchTerm) ||
        className.includes(searchTerm);
    });
  }

  addToHistory(result: any): void {
    this.loadHistory();
  }

  viewHistoryItem(item: any): void {
    if (item?.sheet_data?.length > 0) {

      this.sheetDataList = item.sheet_data;
      this.downloadFilename = item.download_filename || item.file_name;

      this.showsheetDataList = true;
      this.showHistory = false;

      return;
    }

    const fileName = item?.download_filename || item?.file_name;

    if (!fileName) {
      this.alert.showAlertMessage({
        message: 'No data available for this item'
      });
      return;
    }

    this.downloadHistoryFile(fileName);
  }

  downloadHistoryFile(fileName: string): void {
    const clientId = localStorage.getItem('company_id');

    if (!clientId || !fileName) {
      this.alert.showErrorMessage(
        'Missing required information to download file.'
      );
      return;
    }

    const fileLLMformData = new FormData();

    fileLLMformData.append('file_name', fileName);
    fileLLMformData.append('client_id', clientId);

    this.httpLoader.showLoader();

    this.excelservice.downloadSheet(fileLLMformData)
      .pipe(
        finalize(() => {
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: Blob) => {
          const now = new Date();

          const dateString =
            `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}_` +
            `${now.getHours()}-${now.getMinutes()}`;

          importedSaveAs(response, dateString);

          this.alert.showAlertMessage({
            message: 'File downloaded successfully',
            type: 2
          });
        },

        error: (error: HttpErrorResponse) => {
          this.alert.showErrorMessage(
            error?.error?.message || 'Error downloading file.'
          );
        }
      });
  }

  downloadHistoryItem(item: any): void {
    const fileName = item?.download_filename || item?.file_name;

    if (!fileName) {
      this.alert.showErrorMessage('File not available for download.');
      return;
    }

    this.downloadFilename = fileName;
    this.downloadSheet();
  }

  deleteHistoryItem(item: any, index: number): void {
    this.confirmService.openConfirmDialog('', {
      title: 'Delete History Item',
      message: 'Are you sure you want to delete this history item?',
      btnOkText: 'YES',
      btnCancelText: 'NO',

      onClose: (confirmed: boolean) => {
        if (!confirmed) {
          return;
        }

        const clientId = localStorage.getItem('company_id');
        const fileName = item?.file_name || item?.download_filename || item;

        if (!clientId || !fileName || typeof fileName !== 'string') {
          this.alert.showErrorMessage(
            'Missing required information to delete file.'
          );
          return;
        }

        const fileLLMformData = new FormData();

        fileLLMformData.append('file_name', fileName);
        fileLLMformData.append('client_id', clientId);

        this.httpLoader.showLoader();

        this.excelservice.deleteFiles(fileLLMformData)
          .pipe(
            finalize(() => {
              this.httpLoader.hideLoader();
            })
          )
          .subscribe({
            next: (response: any) => {

              if (response?.success === false) {
                this.alert.showErrorMessage(
                  response?.message || 'Unable to delete history item.'
                );
                return;
              }

              // Remove deleted item from history
              const actualIndex = this.historyList.findIndex(
                (history: any) => history === item
              );

              if (actualIndex !== -1) {
                this.historyList.splice(actualIndex, 1);
              }

              // Refresh filtered history
              this.filterHistory();

              this.alert.showAlertMessage({
                message: 'History item deleted successfully',
                type: 2
              });
            },

            error: (error: HttpErrorResponse) => {
              this.alert.showErrorMessage(
                error?.error?.message ||
                'Error deleting history item. Please try again.'
              );
            }
          });
      }
    });
  }


  getmockData() {
    let response: any = {
      "data": [
        {
          "sheet_data": [
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The document provides information about three policies proposed by ABC Corp for Absence Blueprint Policy Document, effective from June 2025. Here are the names of the policies mentioned in the context:\n\n1. Short Term Disability Policy (STD)\n2. Paid Parental Leave Policy (PPL)\n\nThe Short Term Disability (STD) policy provides a benefit of up to 26 weeks of pay when an employee is out of work due to a disability. The policy covers 100% of your pay for 6 or 8 weeks, depending on your delivery type, during pregnancy leaves. It requires a one-week unpaid waiting period before benefits will begin, and employees are allowed to use PTO during the waiting period.\n\nThe Paid Parental Leave (PPL) policy allows employees to bond with a newborn, newly adopted or foster child within 12 months of the event. The lookback period is per event. Employees can take time off in one-week increments and can top up with PTO/Sick. If an employee has been with the company for more than one year, they will receive 6 weeks at 100% of pay, followed by 6 weeks at 50% of pay. If an employee has less than one year of service, they will receive 6 weeks at 100% of pay. The waiting period for PPL is none for pregnancy leaves. Employees must work 30 hours or more per week to be eligible for this policy.",
              "question": "Listout some policies Name"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The client code provided in the context is 1234.",
              "question": "what is the client code?"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "Based on the provided context, it appears that Short Term Disability (STD) does not have both Pay and Job Protection explicitly mentioned. However, the context suggests that certain leaves or benefits may include both pay and job protection. For instance, Paid Parental Leave (PPL) offers both pay and job protection for eligible employees who take leave to bond with a new child.\n\nIn the case of Short Term Disability, it is not explicitly stated whether it includes job protection. However, it does provide pay replacement benefits during an employee's disability. The context mentions that any approval of leave or benefits is subject to applicable law and may also be subject to the company's policies and supporting medical documentation. Therefore, it would be best to consult with the Benefits team at SSI (benefits@ssi.samsung.com) for more detailed information regarding Short Term Disability and its specific provisions related to pay and job protection.",
              "question": "Is Short Term Disability have both Pay and Job Protection?"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The Waiting Period for Short Term Disability (STD) is a one-week unpaid waiting period before benefits will begin. This is stated in the context provided: \"STD requires a one week unpaid waiting period before benefits will begin.\"",
              "question": "what is the Waiting Period for Short Term Disability?"
            }
          ],
          "sheet_name": "Sheet1"
        },
        {
          "sheet_data": [
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The document provides information about three policies proposed by ABC Corp for Absence Blueprint Policy Document, effective from June 2025. Here are the names of the policies mentioned in the context:\n\n1. Short Term Disability Policy (STD)\n2. Paid Parental Leave Policy (PPL)\n\nThe Short Term Disability (STD) policy provides a benefit of up to 26 weeks of pay when an employee is out of work due to a disability. The policy covers 100% of your pay for 6 or 8 weeks, depending on your delivery type, during pregnancy leaves. It requires a one-week unpaid waiting period before benefits will begin, and employees are allowed to use PTO during the waiting period.\n\nThe Paid Parental Leave (PPL) policy allows employees to bond with a newborn, newly adopted or foster child within 12 months of the event. The lookback period is per event. Employees can take time off in one-week increments and can top up with PTO/Sick. If an employee has been with the company for more than one year, they will receive 6 weeks at 100% of pay, followed by 6 weeks at 50% of pay. If an employee has less than one year of service, they will receive 6 weeks at 100% of pay. The waiting period for PPL is none for pregnancy leaves. Employees must work 30 hours or more per week to be eligible for this policy.",
              "question": "Listout some policies Name"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The client code provided in the context is 1234.",
              "question": "what is the client code?"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "Based on the provided context, it appears that Short Term Disability (STD) does not have both Pay and Job Protection explicitly mentioned. However, the context suggests that certain leaves or benefits may include both pay and job protection. For instance, Paid Parental Leave (PPL) offers both pay and job protection for eligible employees who take leave to bond with a new child.\n\nIn the case of Short Term Disability, it is not explicitly stated whether it includes job protection. However, it does provide pay replacement benefits during an employee's disability. The context mentions that any approval of leave or benefits is subject to applicable law and may also be subject to the company's policies and supporting medical documentation. Therefore, it would be best to consult with the Benefits team at SSI (benefits@ssi.samsung.com) for more detailed information regarding Short Term Disability and its specific provisions related to pay and job protection.",
              "question": "Is Short Term Disability have both Pay and Job Protection?"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The Waiting Period for Short Term Disability (STD) is a one-week unpaid waiting period before benefits will begin. This is stated in the context provided: \"STD requires a one week unpaid waiting period before benefits will begin.\"",
              "question": "what is the Waiting Period for Short Term Disability?"
            }
          ],
          "sheet_name": "Sheet2"
        }
      ],
      "file_name": "ABC_Crop_1760763412563.xlsx"
    }

    return response;
  }


}
